module.exports = __webpack_public_path__ + "static/media/demo.2e8fbdba.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/demo.jpg
 ** module id = 364
 ** module chunks = 0
 **/